import moment from "moment";
import { paginationCalculator } from "pagination-calculator";
import React, { useEffect, useState } from "react";
import { BiMessageEdit } from "react-icons/bi";
import ReactStars from "react-rating-stars-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import {
  CreateStarForFavoriteFalse,
  CreateStarForFavoriteTrue,
} from "../Candidates/Search/CandidateSearchView/FavoriteStar";
import { updateJobId } from "../JobOpportunity/Summary/action";
import { resetJobOpportunityInfo, setJobId } from "../JobOpportunity/action";
import { convertToString } from "../JobOpportunity/recurrenceConvertToString/recurrenceConvertToString";
import { setJobEncounterOccurreneUpdateList } from "../JobOpportunity/slice";
import ViewJob from "../ViewJob";
import { resetModifyOccurrence, updateRequest } from "../ViewJob/action";
import { viewJobSelector } from "../ViewJob/selector";
import BackFixedButton from "../common/BackFixedButton/BackFixedButton";
import DataGrid from "../common/DataGrid";
import StarsRenderer from "../common/DataGrid/starsRenderer";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Modal from "../common/Modal/modal";
import MultiSelectBox from "../common/ReactMultiSelect/MultiSelectBox";
import Sidebar from "../common/Sidebar";
import Spinner from "../common/Spinner/spinner";
import DateField from "../common/TextField/dateTime";
import KendoSchedulerDailyEncounter from "../kendoUI/Scheduler/dailyEncounter/KendoSchedulerDailyEncounter";
import GPSInfo from "./GPSInfo";
import ModalGoTo from "./ModalGoTo";
import Unclaimedmodalpopup from "./Unclaimedmodalpopup";
import {
  DeleteMultiShiftJobOccurence,
  UnclaimedbyEmployerApi,
  addNewEncounterOccurence,
  deleteEncounterOccurence,
  deleteJob,
  editPost,
  editSaveTimeOccurrence,
  firstPage,
  getDeleteEmployerReasons,
  getFilterDailyEncounter,
  getUnClaimEmployerReasons,
  gotoPage,
  lastPage,
  loadDailyEncounterInfo,
  loadMasterData,
  nextPage,
  previousPage,
  resetMatchingCandidateInfo,
  setPageSize,
  updateDailyEncounter,
  updateEncounterOccurence,
  updateSort,
} from "./action";
import "./index.css";
import { createHeaders } from "./infoUtilities";
import { shiftsCoverageSelector } from "./selector";
import { setCandidateSearch, setGrouping } from "./slice";
import { toast } from "react-toastify";
import Mentor from "../assets/svg/Mentor";

const DailyEncounterInfo = () => {
  const navigate = useNavigate();
  const [openGps, setOpenGps] = useState({
    show: false,
    jobData: undefined,
  });
  const [openMessaging, setOpenMessaging] = useState({
    open: false,
    jobId: undefined,
  });
  const [deletedata, setdeletedata] = useState({
    show: false,
    jobId: undefined,
  });
  const [Unclaimdata, setUnclaimData] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const headers = createHeaders();
  const empId = login.employerUniqueId;
  const AppuseridValue = login.appUserId;
  const url = config.baseUrl;
  const {
    data,
    pageSize,
    page,
    gridloader,
    matchingCandidateinfo,
    loadingFlag,
    unClaimEmployerReasons,
    deleteEmployerReasons,
    calendarSearch,
    grouping,
  } = useSelector(shiftsCoverageSelector);
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [UnclaimId, setUnclaimId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showUnclaim, setShowUnclaim] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showJobMessageModal, setShowJobMessageModal] = useState(false);
  const [showViewJob, setShowViewJob] = useState(false);
  const {
    encounterData: { jobUniqueId, jobShiftId: encounterId, jobShiftUniqueId },
    calendar,
    pageName,viewJobTitle
  } = location.state || "";
  const [jobSummary, setJobSummary] = useState(null);
  const JobEncounterOccurreneUpdateList = useSelector(
    (state) => state.jobOpportunity.JobEncounterOccurreneUpdateList
  );
  const approvedcandidateList = useSelector(
    (state) => state.jobOpportunity.approvedcandidates
  );
  const { requestData, jobInfo, shift } = useSelector(viewJobSelector);
  const jobsShiftsDepartmentsList = useSelector(store => store.viewJobDetails.jobsShiftsDepartmentsList);
  const [mulJobdetail, setmulJobdetail] = useState({
    JobUniqueId: "",
    jobClaimId: "",
    occurranceDate: "",
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [shiftDate, setShiftDate] = useState("");
  const [showCalendar, setShowCalendar] = useState(calendar || false);
  const [calendarActionData, setCalendarActionData] = useState({});
  // const [group, setGroup] = useState([]);
  // const [resources, setResources] = useState([]);

  // Confirmation Modal Box Dropdown Form initial data
  const [ModalFormData, setModalFormData] = useState({
    reason: "",
    comments: "",
  });

  // Confirmation Modal Box Dropdown Form Error initial data
  const [ErrorsModalFormData, setErrorsModalFormData] = useState({
    reasonError: "",
    commentsError: "",
  });

  // Confirmation Modal Box Dropdown Form HandleChange Function
  const ConfirmationModalBoxHandleChange = (e) => {
    setModalFormData({
      ...ModalFormData,
      [e.target.name]: e.target.value,
    });
  };

  // Delete Confirmation Modal Box Dropdown Form initial data
  const [DeleteModalFormData, setDeleteModalFormData] = useState({
    reason: "",
    comments: "",
  });

  // Delete Confirmation Modal Box Dropdown Form Error initial data
  const [DeleteErrorsModalFormData, setDeleteErrorsModalFormData] = useState({
    reasonError: "",
    commentsError: "",
  });

  // Delete Confirmation Modal Box Dropdown Form HandleChange Function
  const DeleteConfirmationModalBoxHandleChange = (e) => {
    setDeleteModalFormData({
      ...DeleteModalFormData,
      [e.target.name]: e.target.value,
    });
  };

  // Load Main Page API Methods
  useEffect(() => {
    if (config.baseUrl) {
      dispatch(loadMasterData(config.baseUrl, jobShiftUniqueId, empId));
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
      // Unclaim Reasons API Method
      dispatch(getUnClaimEmployerReasons(`${config.baseUrl}`));
      // Delete Reasons API Method
      dispatch(getDeleteEmployerReasons(`${config.baseUrl}`));
      // Load Main Page data
    }
  }, [config.baseUrl]);

  useEffect(() => {
    if (data) {
      setJobSummary(data);
    }
  }, [data]);

  if (
    matchingCandidateinfo?.jobShiftUniqueId &&
    matchingCandidateinfo?.navigateMatchingCandidate &&
    matchingCandidateinfo?.editJobUniqueId
  ) {
    navigate("/matchingcandidate", {
      state: {
        matchingJobid: matchingCandidateinfo?.jobShiftUniqueId,
        acceptableTravelDistance:
          matchingCandidateinfo?.acceptableTravelDistance,
        jobsClaimId: matchingCandidateinfo?.jobsClaimId,
        jobUniqueId: matchingCandidateinfo?.editJobUniqueId,
      },
    });
    dispatch(resetMatchingCandidateInfo());
  }

  const gotoFirstPage = () => {
    dispatch(firstPage()).then(() => {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
  };
  const gotoNextPage = () => {
    dispatch(nextPage()).then(() => {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
  };
  const gotoPreviousPage = () => {
    dispatch(previousPage()).then(() => {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
  };
  const gotoLastPage = () => {
    dispatch(lastPage()).then(() => {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
  };
  const gotoSelectedPage = (page) => {
    dispatch(gotoPage(page)).then(() => {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
  };
  const updatePageSize = (size) => {
    dispatch(setPageSize(size)).then(() => {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
  };
  // While call refresh function API + Form values has been reset
  const refresh = () => {
    if (config.baseUrl) {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
      dispatch(
        setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify([])))
      );
      dispatch(setGrouping({ key: "group", value: [] }));
      dispatch(setGrouping({ key: "resources", value: [] }));
      dispatch(setCandidateSearch({ key: "fromDate", value: "" }));
      dispatch(setCandidateSearch({ key: "toDate", value: "" }));
      dispatch(setCandidateSearch({ key: "candidates", value: "" }));
    }
  };

  const createStarforFavorite = (flag) => {
    const star = {
      size: 20,
      count: 1,
      value: flag ? 1 : 0,
      edit: false,
      color: flag ? "green" : "Grey",
      activeColor: flag ? "green" : "Grey",
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };
  const generateRowData = (data, headers) => {
    const rowData = {};
    headers.forEach((header) => {
      if (header.type === "text") {
        if (typeof header.field === "array") {
          rowData[header.name] = header.field.map((fld) => data[fld]).join(" ");
        } else {
          rowData[header.name] = data[header.field];
          // rowData[header.name] = (
          //   <span style={{ color: data?.isPosted ? "" : "red" }}>
          //     {data[header.field]}
          //   </span>
          // );
        }
        const fistname = data["candidateFirstName"]
          ? data["candidateFirstName"]
          : "";
        const lastName = data["candidateLastName"]
          ? data["candidateLastName"]
          : "";
        const displayname = fistname + " " + lastName;

        if (header.field === "name") {
          // rowData[header.name] = (
          //   <span style={{ color: data?.isPosted ? "" : "red" }}>
          //     {displayname}
          //   </span>
          // );
          rowData[header.name] = displayname;
        }
        if (header.field === "isMentor") {
          const isMentor = data?.isMentor
          rowData[header.name] = displayname.length > 1 ? (
            <span style={{display:"flex", height:"100%",alignItems:"center"}}><Mentor fillColor={isMentor ? "green": "white"} /></span>
          ) : null
        }
        if (header.field === "isFavorite") {
          rowData[header.name] =
            displayname.length > 1 ? (
              <span>{createStarforFavorite(data[header?.field])}</span>
            ) : (
              ""
            );
        }
        // if (header.field === 'locationName') {
        //     rowData[header.name] = <span style={{ color: data?.isPosted ? '' : 'red' }}>{data[header.field]}</span>
        // }
        // isPosted
      } else {
        if (header.field === "isClaimed") {
          // const isClaimedtrure = data['isClaimed'];
          // const isUnClaimedtrure = data['isUnClaimed'];
          const showIcon = true; //gpsStatus !== 0 && gpsStatus !== 3;
          // const iconClass =
          //   isClaimedtrure === true
          //     ? 'green-icon'
          //     : isUnClaimedtrure === true
          //     ? 'yellow-icon'
          //     : 'red-icon';
          let iconClass = "";
          const claimColor = data["anchorColor"];
          iconClass =
            claimColor === 1
              ? "red-icon"
              : claimColor === 2
                ? "yellow-icon"
                : claimColor === 3
                  ? "green-icon"
                  : "";
          if (showIcon) {
            rowData[header.name] = {
              type: "icon",
              class: `icon-align fa fa-anchor ${iconClass}`,
              rightSideText: <span className="bold-text ms-1" style={{color: '#337166'}}>{data?.isConfirmedShift ? 'C' : ''}</span>
            };
          }
        }
        if (header.field === "isUnClaimed") {
          const iconClassforclaimed = "orange-icon";
          const isClaimed = data["isClaimed"];
          const isCheckedIn = data["isCheckedIn"];
          if (isClaimed === true && isCheckedIn === false) {
            rowData[header.name] = [
              {
                type: "icon",
                class: `icon-align fa fa-remove ${iconClassforclaimed}`,
                // onClick: () => {
                //   setUnclaimId({
                //     "candidateUniqueId": data["candidateUniqueId"],
                //     "jobuniqueid": data["jobUniqueId"],
                //     "jobsClaimId": data["jobsClaimId"],
                //     "claimedstatus": 2,
                //     "occurranceDate": data["currentMultiShiftJobDate"]
                //   });
                //   showUnclaimedPopup(data["jobUniqueId"]);
                // },
                onClick: () => {
                  showUnclaimdata(data["jobsClaimId"]);
                },
              },
            ];
          }
          // else if (
          //   jobSummary?.isClaimed === true &&
          //   isClaimed === false &&
          //   !data["candidateUniqueId"]
          // ) 
          else if ((isClaimed === false) && !data['candidateUniqueId']) {
            rowData[header.name] = (
              <BiMessageEdit
                onClick={() =>
                  // viewJobinSamePage(
                  //   data['jobUniqueId'],
                  //   data['currentMultiShiftJobDate'],
                  //   data['jobsClaimId'],
                  //   data['shiftStartTime'],
                  //   data['shiftEndTime'],
                  //   jobShiftUniqueId,
                  //   true
                  // )
                  setShowCalendar(true)
                }
                size={"1.5rem"}
                color={"#20851a"}
                style={{ cursor: "pointer" }}
              />
            );
          }
        }
        // const showIcon = true;
        // const iconClassforclaimed = "orange-icon";
        // const isClaimedchk = data["isClaimed"];
        // const isCheckedInchk = data["isCheckedIn"];
        // if (isClaimedchk === true && isCheckedInchk === false) {
        //   if (showIcon) {
        //     rowData[header.name] = [
        //       {
        //         type: "icon",
        //         class: `icon-align fa fa-remove ${iconClassforclaimed}`,
        //         onClick: () => {
        //           showUnclaimdata(data["jobUniqueId"]);
        //         },
        //       },
        //     ];
        //   }
        // }
        // }
        if (header.field === "isCheckedIn") {
          const isCheckedIn = data[header.field];
          const iconClass = isCheckedIn
            ? "fa-sign-in green-icon"
            : "fa-sign-in red-icon";
          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align ${iconClass}`,
            blink: pageName !== 'awaitingcorrection' ? (data?.notCheckedIn && data?.checkedInCountTime ? true : false) : false,
            data: pageName !== 'awaitingcorrection' ? data?.checkedInCountTime : ''
          };
        }
        if (header.field === "breakTimeFlash") {
          // const icon_color = data?.breakTimeFlash && data?.breakTimeCountTime ? 'green-icon' : 'grey-icon'

          // rowData[header.name] = {
          //   type: "icon",
          //   class: `fa icon-align fa-pause-circle-o ${icon_color}`,
          //   blink: data?.breakTimeFlash && data?.breakTimeCountTime ? true : false,
          //   data: data?.breakTimeCountTime
          // };

          const breakCountFlag = data?.breakTimeFlash;

          const icon_color = breakCountFlag === 0 ? 'grey-icon' : breakCountFlag === 1 || breakCountFlag === 2 ? 'green-icon' : ''

          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align fa-pause-circle-o ${icon_color}`,
            blink: breakCountFlag === 2 ? true : false,
            data: data?.breakTimeCountTime,
            title: data?.brekTypes ? data?.brekTypes : ''
          };


        }
        if (header.field === "isCheckedOut") {
          const isCheckedOut = data[header.field];
          const iconClass = isCheckedOut
            ? "fa icon-align fa-sign-out fa-flip-horizontal green-icon"
            : "fa icon-align fa-sign-out fa-flip-horizontal red-icon";
          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align ${iconClass} me-auto`,
            blink: pageName !== 'awaitingcorrection' ? (data?.notCheckedOut && data?.checkedOutCountTime ? true : false) : false,
            data: pageName !== 'awaitingcorrection' ? (data?.checkedOutCountTime) : ''
          };
        }
        if (header.field === "isPaid") {
          const isPaid = data[header.field];
          const iconClass = isPaid
            ? "green-icon fa-check-circle"
            : "fa-times-circle red-icon";
          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align ${iconClass}`,
          };
        }
        // if (header.field === "edit") {
        //   rowData[header.name] = {
        //     type: "icon",
        //     class: `fa fa-pencil icon-align`,
        //     onClick: () => {
        //       editJob(data["jobUniqueId"], data["isClaimed"]);
        //     },
        //   };
        // }

        if (header.field === "view") {
          rowData[header.name] = {
            type: "icon",
            class: `icon-align fa fa-file`,
            // onClick: () => {
            //   // viewJob(
            //   //   data["jobUniqueId"],
            //   //   data["acceptableTravelDistance"],
            //   //   data["currentMultiShiftJobDate"],
            //   //   data["jobsClaimId"]
            //   // );
            //   viewJobinSamePage(data["jobUniqueId"],
            //     data["currentMultiShiftJobDate"],
            //     data["jobsClaimId"],
            //     data["shiftStartTime"],
            //     data["shiftEndTime"]
            //     , false)
            // },
          };
        }
        // if (header.field === "delete") {
        //   rowData[header.name] = {
        //     type: "icon",
        //     class: `icon-align fe fe-trash-2 fa-lg`,
        //     onClick: () => {
        //       showDeletedata(data["jobUniqueId"]);
        //     },
        //   };
        // }
        // if (header.field === 'message') {
        //     rowData[header.name] = {
        //         type: 'icon',
        //         class: `icon-align fa fa-commenting`,
        //         onClick: () => {
        //             viewJobMessages(data['jobShiftUniqueId'])
        //         }

        //     }
        // }

        if (header.name === "Action") {
          rowData[header.name] = [
            // {
            //   type: "icon",
            //   class: `icon-align fa fa-commenting`,

            //   onClick: () => {
            //     viewJobMessages(
            //       data["jobShiftUniqueId"],
            //       data["isClaimed"],
            //       data["candidateUniqueId"]
            //     );
            //   },
            // },
            {
              type: "icon",
              class: `icon-align fa fa-file green-color-icon`,
              onClick: () => {
                // viewJob(
                //   data["jobUniqueId"],
                //   data["acceptableTravelDistance"],
                //   data["currentMultiShiftJobDate"],
                //   data["jobsClaimId"]
                // );
                viewJobinSamePage(
                  data["jobUniqueId"],
                  data["currentMultiShiftJobDate"],
                  data["jobsClaimId"],
                  data["shiftStartTime"],
                  data["shiftEndTime"],
                  data["jobsShiftUniqueId"],
                  false
                );
              },
            },
            // {
            //   type: "icon",
            //   class: `fa fa-pencil icon-align`,
            //   onClick: () => {
            //     editJob(
            //       data["jobUniqueId"],
            //       data["isClaimed"],
            //       data["acceptableTravelDistance"]
            //     );
            //   },
            // },
            {
              type: "icon",
              class: `icon-align fe fe-trash-2 fa-lg green-color-icon`,
              onClick: () => {
                setShiftDate(data["currentMultiShiftJobDateToDisplay"]);
                warnDelete(
                  data["jobUniqueId"],
                  data["jobsClaimId"],
                  data["currentMultiShiftJobDate"]
                );
              },
            },
          ];
        }
        if (header.field === "ratings") {
          rowData[header.name] = {
            type: "ratings",
            value: data[header.field],
          };
        }
        if (header.name === "Approval") {
          rowData[header.name] = data[header.field]?.map((fld) => {
            const isSuccess = fld.isApproved;
            const iconClass = isSuccess
              ? "green-icon fa-check-circle"
              : "fa-times-circle red-icon";
            return {
              type: "icon",
              class: `fa icon-align ${iconClass}`,
            };
          });
        }
        if (header.field === "gpsTrackingStatus") {
          const gpsStatus = data["gpsCurrentTrackingStatus"];

          const showIcon = true; //gpsStatus !== 0 && gpsStatus !== 3;
          //const iconClass = (gpsStatus === 1 || gpsStatus === 0 || gpsStatus === 3) ? 'green-icon' : gpsStatus === 2 ? 'yellow-icon' : 'red-icon'
          const iconClass =
            gpsStatus === 0
              ? "grey-icon"
              : gpsStatus === 1 || gpsStatus === 3
                ? "green-icon"
                : gpsStatus === 2
                  ? "yellow-icon"
                  : "red-icon";

          if (showIcon) {
            rowData[header.name] = {
              type: "icon",
              class: `icon-align fa fa-map-marker ${iconClass}`,
              onClick: () => {
                showHideGps(data);
              },
            };
          }
        }
      }
    });
    return rowData;
  };

  const createPageData = (page, pageSize, totalCount) => {
    if (page === 1) {
      return {
        from: page,
        to: pageSize,
        total: totalCount,
        totalPages: Math.ceil(totalCount / pageSize),
        currentPage: page,
        pageSize: pageSize,
      };
    } else {
      const pageData = paginationCalculator({
        total: totalCount,
        current: page,
        pageSize: pageSize,
      });
      return {
        from: pageData.showingStart,
        to: pageData.showingEnd,
        total: totalCount,
        totalPages: Math.ceil(totalCount / pageSize),
        currentPage: page,
        pageSize: pageSize,
      };
    }
  };

  const formatTableData = (data) => {
    const tableData = {
      headers,
      rows: data?.scheduleOccurrenceDateWithOpenshift?.map((data) => ({
        columns: generateRowData(data, headers),
      })),
      options: {
        sortable: false,
        filter: false,
        pagination: true,
        pageSize: pageSize || 10,
        height: "100%",
        layout: "autoHeight",
        resizable: true,
        showToggle: true,
        refreshFlag: true,
        gridloader,
        loader: true,
      },
      pageData: createPageData(page, pageSize, data?.totalCount),
      totalCount: data?.totalCount,
      currentPage: page,
      pageSize,
      firstPage: gotoFirstPage,
      nextPage: gotoNextPage,
      previousPage: gotoPreviousPage,
      lastPage: gotoLastPage,
      updatePageSize: updatePageSize,
      gotoPage: gotoSelectedPage,
      headerComponentParams: {
        sort: (order, column) => {
          dispatch(updateSort(order, column)).then(() => {
            dispatch(
              loadDailyEncounterInfo({
                url: config.baseUrl,
                shiftUniqueId: jobShiftUniqueId,
                jobUniqueId: jobUniqueId,
              })
            );
          });
        },
        headers,
      },
    };
    return tableData;
  };
  const viewJobinSamePage = (
    jobId,
    shiftDate,
    claimId,
    shiftStartTime,
    shiftEndTime,
    jobsShiftUniqueId,
    save
  ) => {
    dispatch(
      updateRequest({
        jobId,
        shiftDate,
        claimId,
        shiftStartTime,
        shiftEndTime,
        jobsShiftUniqueId,
        save,
        viewJobTitle
      })
    ).then(() => {
      setShowViewJob(!showViewJob);
    });
  };

  const closeViewJob = () => {
    setShowViewJob(!showViewJob);
    dispatch(resetModifyOccurrence());
  };

  const saveViewJob = () => {
    const params = {
      jobShiftUniqueId: jobShiftUniqueId,
      shiftDateTime: requestData?.shiftDate,
      shiftStartTime: shift?.startTime?.name,
      shiftEndTime: shift?.endTime?.name,
      incentive: jobInfo?.incentive?.toString(),
      jobsClaimId: requestData?.claimId,
      candidateDepartmentId: jobsShiftsDepartmentsList?.length  ? jobsShiftsDepartmentsList?.at(0)?.id : [],
      DepartmentName: jobsShiftsDepartmentsList?.length ? jobsShiftsDepartmentsList?.at(0)?.name : []
    };
    dispatch(
      editSaveTimeOccurrence(
        `${config.baseUrl}/Employers/savejobsunclaimedoccurance`,
        params
      )
    )
      .then(() => {
        setShowViewJob(!showViewJob);
      })
      .then(() => dispatch(resetModifyOccurrence()));
  };

  const viewJob = (jobId, acceptableTravelDistance, shiftDate, claimId) => {
    dispatch(updateJobId(jobId, "/openshifts")).then(() => {
      navigate("/jobsummary", {
        state: {
          jobUniqueId: jobId,
          jobDate: shiftDate,
          jobsClaimId: claimId,
          gotoMatching: true,
          save: false,
          acceptableTravelDistance: acceptableTravelDistance,
        },
      });
    });
  };
  const GoBackToPage = () => {
    dispatch(firstPage());
    navigate(-1);
  };
  // const viewJobMessages = (jobId, isClaimed, candidateId) => {
  //   // if (!isClaimed) {
  //   //     setShowMessageModal (!showMessageModal)
  //   // } else {

  //   navigate("/jobmessages", {
  //     state: {
  //       jobUniqueId: jobId,
  //       candidateUniqueId: candidateId,
  //     },
  //   });
  //   // }
  // };
  const clickJobMessages = (jobId, candidateId) => {
    if (!candidateId) {
      setShowMessageModal(!showMessageModal);
    } else {
      navigate("/jobmessages", {
        state: {
          jobUniqueId: jobId,
          candidateUniqueId: candidateId,
        },
      });
    }
  };

  // const editJob = (jobId, isClaimed, acceptableTravelDistance) => {

  //   if (isClaimed) {
  //     setShowJobMessageModal(!showJobMessageModal);
  //   } else {
  //     dispatch(resetJobOpportunityInfo()).then(() => {
  //       dispatch(editPost()).then(() => {
  //         dispatch(setJobId(jobId)).then(() => {
  //           navigate("/jobopportunity", {
  //             state: {
  //               acceptableTravelDistance: acceptableTravelDistance,
  //             },
  //           });
  //         });
  //       });
  //     });
  //   }
  // };

  const cancelJobView = () => {
    dispatch(updateJobId(undefined)).then(() => {
      navigate("/shiftscoverage");
    });
  };

  const showHideGps = (jobData) => {
    if (jobData && jobData.jobUniqueId) {
      setOpenGps({
        show: true,
        jobData: jobData,
      });
    } else {
      setOpenGps({
        show: false,
        jobData: undefined,
      });
    }
  };
  const handleClose = () => setShow(false);
  const handleClosefalse = () => {
    setdeletedata({
      show: false,
    });
  };
  const handleCloseUnclaim = () => setShow(false);
  const handleClosefalseUnclaim = () => {
    setUnclaimData({
      show: false,
    });
    setErrorsModalFormData({
      commentsError: "",
      reasonError: "",
    });
    setModalFormData({
      reason: "",
      comments: "",
    });
  };
  const handleDeleteData = () => {
    const params = {
      JobUniqueId: deleteId,
      AppUserId: AppuseridValue,
    };
    dispatch(
      deleteJob({ url: `${config.baseUrl}/Jobs/delete-job-details`, params })
    ).then(() => {
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
    setdeletedata({
      show: false,
    });
  };
  const UnclaimedbyEmployer = () => {
    // Unclaim Reasons Error Handling
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    const params = {
      ...UnclaimId,
      unClaimReasonId: ModalFormData.reason,
      otherUnClaimReason: ModalFormData.comments,
    };
    dispatch(
      UnclaimedbyEmployerApi({
        url: `${config.baseUrl}/Candidates/unclaimoccurrancebyemployer`,
        params,
      })
    )
      .then(() => {
        dispatch(
          loadDailyEncounterInfo({
            url: config.baseUrl,
            shiftUniqueId: jobShiftUniqueId,
            jobUniqueId: jobUniqueId,
          })
        );
      })
      .then(() => {
        setErrorsModalFormData({
          commentsError: "",
          reasonError: "",
        });
        setModalFormData({ reason: "", comments: "" });
        setUnclaimData({ show: false });
      });
  };

  // const showDeletedata = (jobId) => {
  //   setDeleteId(jobId);
  //   if (jobId) {
  //     setdeletedata({
  //       show: true,
  //       jobId: jobId,
  //     });
  //   } else {
  //     setdeletedata({
  //       show: false,
  //       jobId: undefined,
  //     });
  //   }
  // };
  const showUnclaimedPopup = (jobuniId) => {
    if (jobuniId) {
      setUnclaimData({
        show: true,
        jobId: jobuniId,
      });
    } else {
      setUnclaimData({
        show: false,
        jobId: undefined,
      });
    }
  };
  const hideModal = () => {
    setShowModal(!showModal);
  };

  const hideMessageModal = () => {
    setShowMessageModal(!showMessageModal);
  };

  const hideJobMessageModal = () => {
    setShowJobMessageModal(!showJobMessageModal);
  };

  const warnDelete = (jobUniqueId, jobClaimId, currentMultiShiftJobDate) => {
    setmulJobdetail({
      JobUniqueId: jobUniqueId,
      jobClaimId: jobClaimId,
      occurranceDate: currentMultiShiftJobDate,
    });
    setDeleteModal();
  };

  const setDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
    setDeleteModalFormData({
      reason: "",
      comments: "",
    });
    setDeleteErrorsModalFormData({
      reasonError: "",
      commentsError: "",
    });
  };

  const deleteMultishift = () => {
    // Error Handling for single shift delete Reasons in Dropdown
    if (!DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(DeleteModalFormData.reason) === 0) {
        if (!DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            ...DeleteErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    // delete parameters
    const params = {
      ...mulJobdetail,
      jobShiftsUniqueId: jobShiftUniqueId,
      deleteReasonId: DeleteModalFormData.reason,
      otherDeleteReason: DeleteModalFormData.comments,
    };
    // delete API Method
    dispatch(DeleteMultiShiftJobOccurence(config.baseUrl, params))
      .then(() => {
        setDeleteModal();
        dispatch(
          loadDailyEncounterInfo({
            url: config.baseUrl,
            shiftUniqueId: jobShiftUniqueId,
            jobUniqueId: jobUniqueId,
          })
        );
      })
      .then(() => {
        setDeleteModalFormData({
          reason: "",
          comments: "",
        });
      });
  };

  const handleCalenderModalSave = (value) => {
    // dispatch(
    //   setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify(value)))
    // );
    // dispatch(setJobEncounterOccurreneUpdateList(structuredClone(value)));

    // if (value.length === 0 && JobEncounterOccurreneUpdateList.length > 0) {
    //   dispatch(
    //     setJobEncounterOccurreneUpdateList(
    //       structuredClone(JobEncounterOccurreneUpdateList)
    //     )
    //   );
    // } else {
    //   dispatch(setJobEncounterOccurreneUpdateList(structuredClone(value)));
    // }
    if (value.length === 0 && JobEncounterOccurreneUpdateList.length > 0) {
      dispatch(
        setJobEncounterOccurreneUpdateList(
          JSON.parse(JSON.stringify(JobEncounterOccurreneUpdateList))
        )
      );
    } else {
      dispatch(
        setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify(value)))
      );
    }
  };
  const saveDailyEncounter = () => {
    const dailyEncounterJson = {
      jobsShiftUniqueId: jobShiftUniqueId,

      jobEncounterOccurrenes: JobEncounterOccurreneUpdateList.map(
        (element, index) => {
          return {
            taskID: element.TaskID,
            // title: element.Title ? element.Title : '',
            start: moment(element.Start).utc().format(),
            end: moment(element.End).utc().format(),
            isAllDay: element.isAllDay,
            appointmentType: element.AppointmentType,
            shiftLength: element.ShiftLength,
            patientName: element.PatientName,
            patientPhone: element.PatientPhone,
            patientStreetAddress: element.PatientStreetAddress,
            patientZipCode: element.PatientZipCode,
            PatientState: element.PatientState,
            PatientCity: element.PatientCity,
            billingRate: element.billingRate,
            // mapDetails: element.MapDetails,
            jobsClaimId: element.jobsClaimId ? element.jobsClaimId : 0,
            startText: moment(element.Start).format("YYYY-MM-DDTHH:mm:ss"),
            endText: moment(element.End).format("YYYY-MM-DDTHH:mm:ss"),
          };
        }
      ),
    };
    dispatch(updateDailyEncounter(config.baseUrl, dailyEncounterJson));
  };
  const showUnclaimdata = (unClaimedId) => {
    if (unClaimedId) {
      setUnclaimData(true);
      setUnclaimId(unClaimedId);
    }
  };

  const unclaim = () => {
    singleUnclaimOccurrence(UnclaimId);
  };
  const singleUnclaimOccurrence = (UnclaimId) => {
    // Unclaim Reasons Error Handling
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    const params = {
      jobsClaimId: UnclaimId,
      unClaimReasonId: ModalFormData.reason,
      otherUnClaimReason: ModalFormData.comments,
    };
    dispatch(
      UnclaimedbyEmployerApi({
        url: `${config.baseUrl}/Employers/encounter-unclaimoccurrance`,
        params,
      })
    ).then(() => {
      setUnclaimData(false);
      setUnclaimId("");
      setErrorsModalFormData({
        reasonError: "",
        commentsError: "",
      });
      setModalFormData({
        reason: "",
        comments: "",
      });
      dispatch(
        loadDailyEncounterInfo({
          url: config.baseUrl,
          shiftUniqueId: jobShiftUniqueId,
          jobUniqueId: jobUniqueId,
        })
      );
    });
  };

  const updateAuthorizedUser = (target) => {
    dispatch(setCandidateSearch({ key: "candidates", value: target.value }));
  };

  const updateDates = (target) => {
    dispatch(setCandidateSearch({ key: target.name, value: target.value }));
  };

  const searchCalendarDate = async () => {
    if (!calendarSearch?.candidates?.length > 0) {
      toast.error("Please select Authorized User");
      return;
    }
    const requestBody = {
      jobsShiftUniqueId: jobShiftUniqueId,
      ...calendarSearch,
      fromDate: null,
      toDate: null,
      candidates: calendarSearch.candidates
        ? [
          ...new Set(
            calendarSearch.candidates.map((element) => element.value)
          ),
        ]
        : [],
      locationId: data?.locationId
    };

    const result = await dispatch(
      getFilterDailyEncounter(config.baseUrl, requestBody)
    );
    if (result && result.length) {
      const groupArray = [
        ...new Set(
          result.map((element, index) => {
            return element.name;
          })
        ),
      ];

      dispatch(setGrouping({ key: "group", value: groupArray }));
      dispatch(setGrouping({ key: "resources", value: result }));
      // setGroup(groupArray);
      // setResources(result);
    }
  };

  const buildRequestJson = (array) => {
    const requestJson = array.map((element, index) => {
      return {
        taskID: element.TaskID,
        // title: element.Title ? element.Title : '',
        start: moment(element.Start).utc().format(),
        end: moment(element.End).utc().format(),
        StartText: moment(element.Start).format("YYYY-MM-DDTHH:mm:ss"),
        EndText: moment(element.End).format("YYYY-MM-DDTHH:mm:ss"),
        isAllDay: element.isAllDay,
        appointmentType: element.AppointmentType,
        shiftLength: element.ShiftLength,
        patientName: element.PatientName,
        patientPhone: element.PatientPhone,
        patientStreetAddress: element.PatientStreetAddress,
        patientZipCode: element.PatientZipCode,
        PatientState: element.PatientState,
        PatientCity: element.PatientCity,
        billingRate: element.billingRate,
        // mapDetails: element.MapDetails,
        jobsClaimId: element.jobsClaimId ? element.jobsClaimId : 0,
        startText: moment(element.Start).format("YYYY-MM-DDTHH:mm:ss"),
        endText: moment(element.End).format("YYYY-MM-DDTHH:mm:ss"),
        candidateUniqueId: element.candidateUniqueId,
        shiftUniqueId: element.ShiftUniqueId
          ? element.ShiftUniqueId
          : jobShiftUniqueId,
      };
    });
    return requestJson;
  };

  useEffect(() => {
    const { created, deleted, updated } = calendarActionData;
    //  console.log(calendarSearch.candidates, 'check');
    if (created?.length) {
      dispatch(
        addNewEncounterOccurence(config.baseUrl, {
          jobEncounterOccurrenes: buildRequestJson(created),
        })
      ).then((response) => {
        // console.log({responseCreated:response});
        if (parseInt(response?.statusCode) !== 200) {
          if (calendarSearch?.candidates?.length > 0) {
            searchCalendarDate();
          } else {
            refresh();
          }
        }
      });
    }
    if (updated?.length) {
      dispatch(
        updateEncounterOccurence(config.baseUrl, {
          jobEncounterOccurrenes: buildRequestJson(updated),
        })
      ).then((response) => {
        if (parseInt(response?.statusCode) !== 200) {
          if (calendarSearch?.candidates?.length > 0) {
            searchCalendarDate();
          } else {
            refresh();
          }
        }
      });
    }
    if (deleted?.length) {
      // dispatch(
      //   deleteEncounterOccurence(config.baseUrl, {
      //     jobEncounterOccurrenes: buildRequestJson(deleted),
      //   })
      // );
    }
  }, [calendarActionData]);

  const handleActions = (payload) => {
    // dispatch(setCandidateSearch({ key: "candidates", value: calendarSearch.candidates }));
    //const { created, deleted, updated } = payload;
    setCalendarActionData(payload);
  };
//   useEffect(() => {
//     const handler = (e) => {
//       if(pageName){
//         navigate(`/${pageName}`);
//       }
//     }
//     window.addEventListener("popstate", e => handler(e));
//     return () => {
//         window.removeEventListener("popstate", e => handler(e));
//     }
// }, [])
  return (
    <div className="page main-margin">
      {/* <Loader /> */}
      {loadingFlag > 0 && <Spinner />}

      <Header />
      <Sidebar />

      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                {/* <button
                  className={`btn btn-danger sw-btn-prev`}
                  type="buttobn"
                  onClick={GoBackToPage}
                >
                  Back
                </button> */}

                <h1 className="page-title ms-2">Daily Encounter Info</h1>
                <BackFixedButton
                  btnStyle={`btn-danger`}
                  btnName={"Back"}
                backPage={pageName ? `/${pageName}`:""}
                />
              </div>

              {showViewJob && (
                <ModalGoTo
                  showHide={closeViewJob}
                  save={saveViewJob}
                // backPath={backPath}
                // label={"Job Summary"}
                // relativeToParent = {true}
                >
                  <ViewJob pageName={pageName} closePopup={closeViewJob}/>
                </ModalGoTo>
              )}
              {showMessageModal && (
                <Modal
                  showHide={hideMessageModal}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={true}
                >
                  <span className="fw-bold">
                    There are no Claimed Candidates for this Shift !
                  </span>
                </Modal>
              )}
              {showDeleteModal && (
                <Modal
                  showHide={setDeleteModal}
                  saveFunction={deleteMultishift}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={false}
                  buttonName={"Delete"}
                >
                  <span className="fw-bold">
                    Are you sure want to delete this shift occurrence "
                    {shiftDate}"?
                  </span>
                  <div>
                    {/* Delete Reasons Dropdown */}
                    <div className="mt-5">
                      <label for="reason" className="mx-2">
                        Choose a Reason :
                      </label>
                      <select
                        name="reason"
                        id="reason"
                        className="form-select form-control"
                        required
                        onChange={DeleteConfirmationModalBoxHandleChange}
                      >
                        <option selected disabled>
                          Choose any one
                        </option>
                        {deleteEmployerReasons.map((reasonLists, index) => {
                          return (
                            <option key={index} value={reasonLists.id}>
                              {reasonLists.name}
                            </option>
                          );
                        })}
                      </select>
                      {
                        <span className="text-danger mx-2">
                          {DeleteErrorsModalFormData?.reasonError}
                        </span>
                      }
                      {parseInt(DeleteModalFormData.reason) === 0 ? (
                        <div className="mt-2">
                          <textarea
                            className="form-control"
                            name="comments"
                            value={DeleteModalFormData.comments}
                            onChange={DeleteConfirmationModalBoxHandleChange}
                          ></textarea>
                          {
                            <span className="text-danger mx-2">
                              {DeleteErrorsModalFormData?.commentsError}
                            </span>
                          }
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Modal>
              )}
              {openGps.show && (
                <Modal label={"GPS"} onlyClose={true} showHide={showHideGps}>
                  <GPSInfo {...openGps.jobData} show={openGps.show} />
                </Modal>
              )}
              {Unclaimdata === true ? (
                <Unclaimedmodalpopup
                  showUnclaim={true}
                  handleUnclaimClose={handleClosefalseUnclaim}
                  handleUnclaim={unclaim}
                  children={
                    <div className="mt-5 ">
                      {/* UnClaim Reasons Dropdown */}
                      <div>
                        <label for="reason" className="mx-2">
                          Choose a Reason :
                        </label>
                        <select
                          name="reason"
                          id="reason"
                          className="form-select form-control"
                          required
                          onChange={ConfirmationModalBoxHandleChange}
                        >
                          <option selected disabled>
                            Choose any one
                          </option>
                          {unClaimEmployerReasons.map((reasonLists, index) => {
                            return (
                              <option key={index} value={reasonLists.id}>
                                {reasonLists.name}
                              </option>
                            );
                          })}
                        </select>
                        {
                          <span className="text-danger mx-2">
                            {ErrorsModalFormData?.reasonError}
                          </span>
                        }
                        {parseInt(ModalFormData.reason) === 0 ? (
                          <div className="mt-2">
                            <textarea
                              className="form-control"
                              name="comments"
                              value={ModalFormData.comments}
                              onChange={ConfirmationModalBoxHandleChange}
                            ></textarea>
                            {
                              <span className="text-danger mx-2">
                                {ErrorsModalFormData?.commentsError}
                              </span>
                            }
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  }
                />
              ) : (
                ""
              )}
              <div className="card ">
                <div className="card-body position-relative">
                  {/* <div
                    onClick={() =>
                      clickJobMessages(encounterId, candidateUniqueId)
                    }
                    className=" position-absolute adjust-chat text-primary fs-4"
                  >
                    <i className="icon-align fa fa-commenting h-100 w-100"></i>
                  </div> */}
                  <div class="row row-cols-1">
                    <div className="col-8">
                      <label
                        className="fw-semibold col-3"
                        htmlFor={data?.locationName}
                      >
                        Location Name :
                      </label>
                      <span className="col-9">{data?.locationName}</span>
                    </div>
                    <div className="col-8">
                      <label
                        className="fw-semibold col-3"
                        htmlFor={data?.shiftDate}
                      >
                        Shift Date :
                      </label>
                      <span className="col-9"> {data?.shiftDate}</span>
                    </div>
                    {/* <div className="col-8">
                      <label
                        className="fw-semibold col-3"
                        htmlFor={data?.endDate}
                      >
                        End Date :
                      </label>
                      <span className="col-9"> {data?.endDate}</span>
                    </div> */}
                    {/* <div className="col-8">
                      <label
                        className="fw-semibold col-3"
                        htmlFor={convertToString(
                          data?.jobSummary?.jobSummeryJobsShifts?.recurrenceRule
                        )}
                      >
                        Occurance :
                      </label>
                      <span className="col-9">
                        {" "}
                        {convertToString(
                          data?.jobSummary?.jobSummeryJobsShifts?.recurrenceRule
                        )}
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div class="panel panel-primary">
                        <div class="tab-menu-heading tab-menu-heading-boxed d-flex">
                          <div class="tabs-menu-boxed">
                            <ul class="nav panel-tabs panel-secondary">
                              <li>
                                <a
                                  href="#"
                                  className={!showCalendar ? "active" : ""}
                                  data-bs-toggle="tab"
                                  onClick={() => {
                                    setShowCalendar(false);
                                    refresh();
                                  }}
                                >
                                  Table
                                </a>
                              </li>
                              <li>
                                <a
                                  href="#"
                                  className={showCalendar ? "active" : ""}
                                  data-bs-toggle="tab"
                                  onClick={() => {
                                    setShowCalendar(true);
                                    refresh();
                                  }}
                                >
                                  Calendar
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div className="px-4">
                            <BackFixedButton
                              btnStyle={`btn-danger`}
                              btnName={"Back to Openshift Page"}
                              backPage="/openshifts"
                            />
                          </div>
                        </div>
                        <div className="row pt-4">
                          <div className="col-sm-12">
                            {showCalendar ? (
                              <>
                                <div className="row pt-4 ">
                                  <MultiSelectBox
                                    name="authorizedUser"
                                    title="Authorized User"
                                    value={calendarSearch.candidates}
                                    options={approvedcandidateList}
                                    updateValue={updateAuthorizedUser}
                                    isMultiSelect={true}
                                    hideSelectedOptions={true}
                                    closeListOnSelect={false}
                                    isMandatory={true}
                                    showCheckbox={true}
                                    divClass={`col-lg-5 col-md-5`}
                                  />
                                  {/* <DateField
                                    name={"fromDate"}
                                    divClass={`col-lg-2 col-md-2`}
                                    label={"Start Date"}
                                    id={"date"}
                                    value={calendarSearch.fromDate}
                                    updateValue={updateDates}
                                    includeTime={false}
                                    isMandatory={true}
                                    // errors={props.errors['shiftDate']}
                                  />
                                  <DateField
                                    name={"toDate"}
                                    divClass={`col-lg-2 col-md-2`}
                                    label={"End Date"}
                                    id={"date"}
                                    value={calendarSearch.toDate}
                                    updateValue={updateDates}
                                    includeTime={false}
                                    isMandatory={true}
                                    // errors={props.errors['shiftDate']}
                                  /> */}
                                  {/* Get Schedule */}
                                  <div className="col-lg-3 col-md-3">
                                    <div className="d-flex gap-3">
                                      <button
                                        style={{ marginTop: "1.75rem" }}
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={searchCalendarDate}
                                      >
                                        Get Schedule
                                      </button>
                                      {/* Clear Button */}
                                      <button
                                        style={{ marginTop: "1.75rem" }}
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={refresh}
                                      >
                                        Clear
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="row pt-4 ">
                                  <KendoSchedulerDailyEncounter
                                    // startDate={
                                    //   JobEncounterOccurreneUpdateList &&
                                    //   JobEncounterOccurreneUpdateList.length &&
                                    //   JobEncounterOccurreneUpdateList[0]?.Start
                                    // }
                                    startDate={data?.shiftDate}
                                    handleSave={handleCalenderModalSave}
                                    multiShiftData={
                                      JobEncounterOccurreneUpdateList
                                    }
                                    grouping={{
                                      default: true,
                                      group: grouping.group,
                                      resources: grouping.resources,
                                      showWeek: true,
                                      showMonth: true,
                                      // showNextPrevious: true
                                      changeCurrentSchedularDate: false
                                    }}
                                    editable={{
                                      add: true,
                                      remove: false,
                                      drag: true,
                                      resize: true,
                                      edit: true,
                                    }}
                                    handleActions={handleActions}
                                  />
                                </div>
                              </>
                            ) : (
                              <DataGrid
                                {...formatTableData(data)}
                                refresh={refresh}
                                pageName={'dailyEncounter'}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {showCalendar ? (
                    <div className="d-flex justify-content-end align-items-center mt-4 ">
                      <button
                        className="btn btn-primary "
                        type="button"
                        onClick={saveDailyEncounter}
                      >
                        Save
                      </button>
                    </div>
                  ) : (
                    ''
                  )} */}
                </div>
              </div>
              <div class="mt-2 pull-right">
                <BackFixedButton
                  btnStyle={`btn-danger`}
                  btnName={"Back"}
                  backPage={pageName ? `/${pageName}`:""}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyEncounterInfo;
